import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';

export const getUpdatedPages = (pages, componentConfig) => {
  const newPages = [...pages];

  newPages.forEach((page) => {
    const { components } = page;
    const newComponents = [];

    components.forEach((cmp) => {
      if (cmp.id === componentConfig.id) {
        newComponents.push(cloneDeep(componentConfig));
      } else {
        newComponents.push(cmp);
      }
    });

    page.components = newComponents; // eslint-disable-line no-param-reassign
  });

  return newPages;
};
